module.exports = __webpack_public_path__ + "static/media/icon_instrument_flute.0d2abddd.svg";